import * as d3 from 'd3-ease';
import * as turf from '@turf/turf';
import mapboxgl from "mapbox-gl";

import { getWindowPercentageInPx } from "../utils";
import { findFirstLevelIdOfStage } from '../finder';
import { createFeatureCollection, getLevelData, projectLevelSource } from "./mapboxDataSource";

export function updateMapLevelImage(map, stageIds, levelIds, projectData) {
    let levelId;
    if (levelIds.length > 0) {
        levelId = levelIds[levelIds.length - 1];
    } else if (stageIds.length > 0) {
        const lastStageId = stageIds[stageIds.length - 1];
        levelId = findFirstLevelIdOfStage(projectData.levels, lastStageId);
    } else {
        levelId = Object.keys(projectData.levels)[0];
    }
    if (levelId) {
        const levelData = getLevelData(projectData, projectData.levels[levelId]);
        const projectLevelImageSource = projectLevelSource(levelData);
        const mapImageSource = map.getSource('projectLevel');
        if (mapImageSource.url !== projectLevelImageSource.url) {
            mapImageSource.updateImage(projectLevelImageSource);
        }
    }
}

export function updateFeaturesOnMapAndFitCamera(map, featuresGroups) {
    let allFeatures = [];
    for (const featureGroupId in featuresGroups) {
        allFeatures = allFeatures.concat(featuresGroups[featureGroupId]);
    }
    const featureCollection = createFeatureCollection(allFeatures);
    map.getSource('cards').setData(featureCollection.data);
    if (featureCollection.data.features.length) {
        fitCameraOnMapFeatures(map, featureCollection);
    }
}

let isCameraFitted = false;
export function fitCameraOnMapFeatures(map, featureCollection) {
    if (isCameraFitted) return;
    const featuresBbox = turf.bbox(featureCollection.data);
    const bboxPolygon = turf.bboxPolygon(featuresBbox);
    const coordinates = bboxPolygon.geometry.coordinates[0];
    const bounds = new mapboxgl.LngLatBounds(
        coordinates[0],
        coordinates[0]
    );
    for (const coord of coordinates) {
        bounds.extend(coord);
    }
    const paddingInPx = getWindowPercentageInPx(0.3);
    const paddingTopInPx = getWindowPercentageInPx(0.5);
    map.fitBounds(bounds, {
        padding: {
            top: paddingTopInPx,
            bottom: paddingInPx,
            left: paddingInPx,
            right: paddingInPx,
        },
        bearing: 0,
        pitch: 60,
        easing: d3.easeCubic
    });
    isCameraFitted = true;
}

export function removeFeaturesHighlight(map) {
    const features = map.querySourceFeatures('cards');
    features.forEach(feature => {
        map.setFeatureState(
            { source: 'cards', id: feature.id },
            { highlight: false }
        );
    })
}